import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
  SiCss3,
  SiRedux,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
import img from "../../Assets/reliance_digital.png";
//import image from "../../Assets/tripadvisor.png";

export const Projects = () => {
  return (
    <div  id="projects">
      <div className="section" >
        <h2 className="section__title different" data-aos="fade-right" id="pro">
          Projects
        </h2>
        <div className="project-card">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={img}
                  alt="Images"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2 className="project-title">Reliance Digital</h2>
              <p className="project-description">
              Clone of An E-Commerce web application Reliance Digital to purchase Electronic items related Products.
              </p>
              <div className="project-tech-stack">
              <SiHtml5/>
              <SiJavascript />
              <SiCss3 />
                
                
              </div>
              <div>
                <a  class="project-deployed-link"
                  href="https://astounding-babka-e9b854.netlify.app/index1.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    URL for the API
                  </span>
                </a>
                <a className="project-github-link"
                  href="https://github.com/Rakesh7420/Reliance-Project"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="project-card">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://cohn.files.wordpress.com/2009/02/indeedcom.png"
                  alt="Practo"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2 className="project-title">Indeed.com</h2>
              <p className="project-description">
             Indeed.com is an American Worldwide employment website for job listings.
             It's a collaborative projects completed executed in 5 days.
              </p>
              <div className="project-tech-stack">
              <SiHtml5/>
              <SiJavascript />
              <SiCss3 />
              </div>
              <div>
                <a class="project-deployed-link"
                  href="https://chic-starship-330803.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a className="project-github-link"
                  href="https://github.com/KanhaiyaChauhan037/Bitter-level-627"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="project-card">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
              <img
                  src="https://th.bing.com/th/id/OIP.fiDPPXm0iO66GOk-az9uTQHaDY?pid=ImgDet&rs=1"
                  alt="Practo"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2 className="project-title">Tripadvisor</h2>
              <p className="project-description">
                A web application to where user can serach visiting places according to the cities, It's a solo project.
              </p>
              <div className="project-tech-stack">
                <FaReact />
                <SiHtml5 />
                <SiCss3 />
                <IoLogoJavascript />
                <SiMaterialui />
                
                {/* <SiExpress /> */}
                {/* <SiMongodb /> */}
              </div>
              <div>
                <a class="project-deployed-link"
                  href="https://capable-sunflower-37cdf9.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a className="project-github-link"
                  href="https://github.com/ruchipriya1009/vital-route-7034"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="project-card">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://topbestalternative.com/wp-content/uploads/2019/12/booking-com-home-screen.png"
                  alt="To-Do-App"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2 className="project-title">Booking.com</h2>
              <p className="project-description">
              Booking.com, Redux project where a user can book hotel, flights, taxis. 
              sort and filter, search and book through this site .
              </p>
              <div className="project-tech-stack">
              <SiHtml5 />
                <SiReactrouter />
              <FaReact />
                <SiCss3 />
                <SiRedux/>
                <SiMaterialui />
                
 
              </div>
              <div>
                <a class="project-deployed-link"
                  href="https://booking-come-1562.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a className="project-github-link"
                  href="https://github.com/ruchipriya1009/scared-shade-6052"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="project-card">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://i.ibb.co/PMny3hW/Screenshot-406.png"
                  alt="TicTacToe"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Star Wars Search</h2>
              <p>
                Vanilla JS web app to Search for any Star Wars Character. Build with the help of Star Wars API and has the Classic UI (Color theme) of the original Star Wars Movie. Built to learn APIs and use them in the project.
              </p>
              <div>
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  href="https://searchstarwars.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/imbickydutta/starWarsCharacterSearch"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};
